import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import Cookies from 'js-cookie';
import { getCurrentLocationAndLanguage, LocationKey } from '@utils/location';
interface EditPermissionContextProps {
  isEditingDisabled: boolean;
}
const EditPermissionContext = createContext<EditPermissionContextProps>({
  isEditingDisabled: true
});
export const useEditPermission = () => useContext(EditPermissionContext);
interface EditPermissionProviderProps {
  children: ReactNode;
}
export const EditPermissionProvider: React.FC<EditPermissionProviderProps> = ({
  children
}) => {
  const [isEditingDisabled, setIsEditingDisabled] = useState<boolean>(true);
  useEffect(() => {
    const editingPermissions: {
      [key: string]: string[];
    } = {
      tr: ['tr'],
      kg: ['kg'],
      kz: ['kz'],
      az: ['az'],
      iq: ['iq'],
      ge: ['ge'],
      uz: ['uz']
    };
    const canEdit = (userState: string | undefined, location: string | undefined): boolean => {
      if (!userState || !location) return false;
      return editingPermissions[userState]?.includes(location) ?? false;
    };
    const userCookie = Cookies.get('user');
    let userState: string | undefined;
    if (userCookie) {
      try {
        const parsedUser = JSON.parse(userCookie);
        userState = parsedUser.extraFields?.state;
      } catch (error) {}
    }
    const {
      location: currentLocation
    } = getCurrentLocationAndLanguage();
    setIsEditingDisabled(!canEdit(userState, currentLocation as LocationKey));
  }, []);
  return <EditPermissionContext.Provider value={{
    isEditingDisabled
  }} data-sentry-element="unknown" data-sentry-component="EditPermissionProvider" data-sentry-source-file="edit-permission.tsx">
      {children}
    </EditPermissionContext.Provider>;
};